import React, { useState, useRef } from 'react';
import {
  Typography,
  Select,
  Checkbox,
  Tooltip,
  Divider,
  Radio,
  Space,
  Input,
  message,
  Button,
} from 'antd';
import axios from 'axios';
import { InfoCircleOutlined } from '@ant-design/icons';
import { getChannelList } from '../../../skills/skills_action';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const IssueCardNotification = ({
  notificationDisplayFormat,
  setNotificationDisplayFormat,
  notificationCollapseMessage,
  setNotificationCollapseMessage,
  notificationArchiveInfo,
  setNotificationArchiveInfo,
  notificationShowFullIssueCard,
  setNotificationShowFullIssueCard,
  disableShowLastUpdate,
  setDisableShowLastUpdate,
  notificationArchiveInfoErrors,
  selectedChannelOption,
  setSelectedChannelOption,
  setNotificationArchiveInfoErrors,
  channelid,
  subscription,
  isRealTimeNotification,
  ...props
}) => {
  const dispatch = useDispatch();
  const team = useSelector((state) => state.common_reducer.team);
  const { Text } = Typography;
  const { Option } = Select;
  const channel_options = [
    { label: 'Existing Channel', value: 'existing_channel' },
    { label: 'New Channel', value: 'new_channel' },
  ];

  const channels = useSelector((state) => state.skills.channels);
  const handlecardResolvedState = (value, type) => {
    try {
      if (type === 'collapse') {
        setNotificationCollapseMessage(value);
        if (value) {
          setNotificationArchiveInfo({
            ...notificationArchiveInfo,
            enabled: false,
          });
        }
      } else {
        setNotificationArchiveInfo({
          ...notificationArchiveInfo,
          enabled: value,
        });
        if (value) {
          setNotificationCollapseMessage(false);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    dispatch(getChannelList(props.match.params.wId));
  }, []);
  const askPermissionHandler = async () => {
    const isValidData = props.updateIssueCardConfigChanges();
    if (isValidData === true) {
      let response =
        team && team.app_id && team.app_id === 'A03UG41QG6T'
          ? { data: { success: true, client_id: '453340678869.3968137832231' } }
          : await axios.post('/bot/new_user_oauth');
      if (response) {
        if (response.data && response.data.success) {
          let baseurl = 'https://slack.com/oauth/v2/authorize?client_id=';
          let client_id = response.data.client_id;
          let scopes = `&user_scope=chat:write&state=archiveTokenInfo:${channelid}:${subscription}`;
          let url = baseurl + client_id + scopes;
          window.open(url, '_self'); //_self opens the url in current window
        }
      }
      let data = {
        user_id: this.props.user._id,
        workspace_id: this.props.workspace._id,
      };
      // let res = await axios.post(`/bot/haspermission/${data.workspace_id}/user/${data.user_id}`);
      let res = await axios.post(
        `/bot/api/w/${data.workspace_id}/haspermission/user/${data.user_id}`
      );
      if (res) {
        if (res.data && res.data.success) {
          //SET HAS PERMISSIONS TRUE / FALSE DEPENDING ON THIS CALL
          this.setState({ hasPermission: response.data.hasPermission }, () => {
            if (response.data.hasPermission) {
              message.success('Permissions Given Successfully!');
            }
            // else{
            //   message.error("Permission Denied")
            // }
          });
          //message.success("Permissions Given Successfully!")
        }
      }
    }
  };
  return (
    <div style={{ height: '200px', overflowY: 'scroll', overflowX: 'hidden' }}>
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
        <Text strong>Display format </Text>
        <Select
          style={{ width: 350 }}
          placeholder='Please select'
          value={notificationDisplayFormat}
          onChange={(value) => setNotificationDisplayFormat(value)}
        >
          <Option key='standard' value='standard'>
            Standard
          </Option>
          <Option key='compact' value='compact'>
            Compact
          </Option>
          <Option key='detailed' value='detailed'>
            Detailed
          </Option>
        </Select>
      </div>
      <Space direction='vertical'>
        {notificationDisplayFormat !== 'detailed' && (
          <Checkbox
            checked={notificationShowFullIssueCard}
            onChange={() =>
              setNotificationShowFullIssueCard(!notificationShowFullIssueCard)
            }
          >
            Show full issue card in thread
          </Checkbox>
        )}
        {isRealTimeNotification && (
          <Checkbox
            checked={!disableShowLastUpdate}
            onChange={() => setDisableShowLastUpdate(!disableShowLastUpdate)}
          >
            Show last update
          </Checkbox>
        )}
      </Space>

      <Divider style={{ margin: '12px' }} />
      <div>
        <div style={{ marginBottom: '12px' }}>
          {' '}
          <Text>
            Choose what happens to the issue card once the issue is resolved
          </Text>
        </div>

        <Space direction='vertical'>
          <Checkbox
            checked={notificationCollapseMessage}
            onChange={() =>
              handlecardResolvedState(!notificationCollapseMessage, 'collapse')
            }
          >
            Collapse message in thread once the issue card is resolved{' '}
            <Tooltip title='This message will contain only the title in the channel with the rest information in thread'>
              <InfoCircleOutlined />
            </Tooltip>
          </Checkbox>
          <Checkbox
            checked={notificationArchiveInfo.enabled}
            onChange={() =>
              handlecardResolvedState(
                !notificationArchiveInfo.enabled,
                'archive'
              )
            }
          >
            Archive message to another channel{' '}
            <Tooltip title='Message will be removed from current channel and moved to selected archive channel'>
              <InfoCircleOutlined />
            </Tooltip>
          </Checkbox>
        </Space>

        {notificationArchiveInfo && notificationArchiveInfo.enabled && (
          <>
            <div style={{ marginTop: '12px' }}>
              <Radio.Group
                options={channel_options}
                onChange={(event) => {
                  setNotificationArchiveInfoErrors('');
                  setSelectedChannelOption(event.target.value);
                  if (event.target.value === 'existing_channel') {
                    setNotificationArchiveInfo({
                      ...notificationArchiveInfo,
                      newChannelName: '',
                    });
                  }
                }}
                value={selectedChannelOption}
                optionType='button'
                buttonStyle='solid'
              />
            </div>

            {notificationArchiveInfoErrors && (
              <div style={{ marginTop: '12px', color: 'red' }}>
                {notificationArchiveInfoErrors}
              </div>
            )}
            <div style={{ marginTop: '12px' }}>
              {selectedChannelOption === 'new_channel' ? (
                <Input
                  style={{ width: '40%' }}
                  placeholder='Enter Channel Name'
                  onChange={(event) =>
                    setNotificationArchiveInfo({
                      ...notificationArchiveInfo,
                      newChannelName: event.target.value,
                    })
                  }
                  value={notificationArchiveInfo.newChannelName || ''}
                />
              ) : (
                <div>
                  {' '}
                  <Select
                    showSearch
                    placeholder='Select Channel'
                    style={{ width: '40%' }}
                    value={notificationArchiveInfo.channel}
                    onChange={(value) =>
                      setNotificationArchiveInfo({
                        ...notificationArchiveInfo,
                        channel: value,
                      })
                    }
                    optionFilterProp='children'
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {channels &&
                      channels.map((channel, index) => (
                        <Option
                          key={channel.id}
                          value={channel.id}
                          name={channel.name}
                        >
                          {channel.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              )}
            </div>
            <div style={{ marginTop: '12px' }}>
              {notificationArchiveInfo &&
              notificationArchiveInfo.userTokenInfo ? (
                <a
                  onClick={() => {
                    setNotificationArchiveInfo({
                      ...notificationArchiveInfo,
                      userTokenInfo: null,
                    });
                  }}
                >
                  De-authorize Troopr from deleting messages on behalf of{' '}
                  {notificationArchiveInfo.userTokenInfo.displayName ||
                    notificationArchiveInfo.userTokenInfo.name}
                </a>
              ) : (
                <div>
                  <span>
                    {' '}
                    Authorize troopr to delete messages on your behalf
                    (Recommended)
                  </span>
                  &nbsp;&nbsp;&nbsp;
                  <Button onClick={() => askPermissionHandler()}>
                    Give Permission{' '}
                  </Button>
                </div>
              )}
              <br />
              <br />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default withRouter(IssueCardNotification);
